module.exports = __webpack_public_path__ + "static/media/Bidoof_gaussian2.44190af9.png";